// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__vxcNY","copyright":"style_copyright__Mg+Am","social_media":"style_social_media__yHEAl","social_link":"style_social_link__jXqi8"};